import { useMemo } from 'react';

import _ from 'lodash';

import { growthModelApiService } from '../../../services/growthModelApi.service';
import { createApiSlice } from '../utils/createApiSlice';

const getGrowthModelApiGrowthStagesSlice = createApiSlice({
  reducerPath: ['growthModelApiAdmin', 'getGrowthModelApiGrowthStages'],
  apiFunction: growthModelApiService.getGrowthStages,
  getStateUpdatePath: (action) => {
    const fieldId = _.get(action, 'payload.apiArguments.0');
    const growthId = _.get(action, 'payload.apiArguments.1');
    return [fieldId, growthId];
  },
  getSelectorPath: (fieldId, growthId) => {
    return [fieldId, growthId];
  },
  apiArgumentsFn: ({ fieldId, growthId }) => [fieldId, growthId]
});

const { actions, useApiSelectors } = getGrowthModelApiGrowthStagesSlice;

export const getGrowthModelApiGrowthStagesActions = actions;

export const useGetGrowthModelApiGrowthStagesSelectors = (
  fieldId,
  growthId
) => {
  const { inProgress, errorMessage, success, updatedAt, response } =
    useApiSelectors(fieldId, growthId);

  return useMemo(
    () => ({
      inProgress,
      errorMessage,
      success,
      updatedAt,
      response
    }),
    [errorMessage, inProgress, response, success, updatedAt]
  );
};

export default getGrowthModelApiGrowthStagesSlice;
